var map = {
	"./flag-blue.svg": "beb4",
	"./flag-burgundy.svg": "4a20",
	"./flag-green.svg": "5788",
	"./flag-red.svg": "ea84",
	"./flag-yellow.svg": "7acf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "766b";